import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import InteractiveOSINT from './InteractiveOSINT';

const OSINTPanel = () => {
  return <InteractiveOSINT />;
};

export default OSINTPanel;